// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Nqh_","importantInfo":"styles_importantInfo__3DUx3"};